import type { RuleHit } from '../types';

export const MOCK_RULE_HITS: RuleHit[] = [
  { ruleName: 'Velocity Limit Exceeded', hits: 142, category: 'Fraud' },
  { ruleName: 'Large Transfer to High-Risk Jurisdiction', hits: 98, category: 'AML' },
  { ruleName: 'Structuring Detected', hits: 87, category: 'AML' },
  { ruleName: 'Sanctions List Match', hits: 64, category: 'Sanctions' },
  { ruleName: 'Rapid Account Balance Change', hits: 53, category: 'Fraud' },
  { ruleName: 'Round-Dollar Transactions', hits: 41, category: 'AML' },
  { ruleName: 'Geographic Anomaly', hits: 36, category: 'Fraud' },
  { ruleName: 'Multiple Beneficiaries in 24h', hits: 29, category: 'Fraud' },
  { ruleName: 'Unexpected Weekend Activity', hits: 22, category: 'AML' },
].sort((a, b) => b.hits - a.hits);
